import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/logo.svg'
import _imports_1 from '../assets/Google-icon-btn.svg'


const _hoisted_1 = { class: "lg:mt-20 sm:mt-20 sm:max-h-screen flex min-h-full flex-1 flex-col justify-center py-12 sm:px-6 lg:px-8" }
const _hoisted_2 = { class: "sm:mx-auto sm:w-full sm:max-w-md" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "mx-auto h-10 w-auto",
  src: _imports_0,
  alt: "Your Company"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-6 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900" }, "Login in to your account", -1)
const _hoisted_5 = { class: "mt-10 sm:mx-auto sm:w-full sm:max-w-[480px]" }
const _hoisted_6 = { class: "bg-white px-6 py-12 shadow sm:rounded-lg sm:px-12" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("form", {
  class: "space-y-6",
  action: "#",
  method: "POST"
}, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("label", {
      for: "email",
      class: "block text-sm font-medium leading-6 text-gray-900"
    }, "Email address"),
    /*#__PURE__*/_createElementVNode("div", { class: "mt-2" }, [
      /*#__PURE__*/_createElementVNode("input", {
        id: "email",
        name: "email",
        type: "email",
        autocomplete: "email",
        required: "",
        class: "block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("label", {
      for: "password",
      class: "block text-sm font-medium leading-6 text-gray-900"
    }, "Password"),
    /*#__PURE__*/_createElementVNode("div", { class: "mt-2" }, [
      /*#__PURE__*/_createElementVNode("input", {
        id: "password",
        name: "password",
        type: "password",
        autocomplete: "current-password",
        required: "",
        class: "block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-between" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
      /*#__PURE__*/_createElementVNode("input", {
        id: "remember-me",
        name: "remember-me",
        type: "checkbox",
        class: "h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
      }),
      /*#__PURE__*/_createElementVNode("label", {
        for: "remember-me",
        class: "ml-3 block text-sm leading-6 text-gray-900"
      }, "Remember me")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "text-sm leading-6" }, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "#",
        class: "font-semibold text-indigo-600 hover:text-indigo-500"
      }, "Forgot password?")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("button", {
      type: "submit",
      class: "flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
    }, "Log in")
  ])
], -1)
const _hoisted_8 = {
  "mx-auto": "",
  flex: "",
  "justify-center": "",
  "items-center": ""
}
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"relative mt-10\"><div class=\"absolute inset-0 flex items-center\" aria-hidden=\"true\"><div class=\"w-full border-t border-gray-200\"></div></div><div class=\"relative flex justify-center text-sm font-medium leading-6\"><span class=\"bg-white px-6 text-gray-900\">Or continue with</span></div></div>", 1)
const _hoisted_10 = { class: "mx-auto mt-6 items-center justify-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "h-6"
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-semibold leading-6" }, "Google", -1)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "mt-10 text-center text-sm text-gray-500" }, [
  /*#__PURE__*/_createTextVNode(" Don't have account? " + /*#__PURE__*/_toDisplayString(' ') + " "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/signup",
    class: "font-semibold leading-6 text-indigo-600 hover:text-indigo-500"
  }, "Create Account")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("a", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.signInWithGoogle && $setup.signInWithGoogle(...args))),
              href: "#",
              class: "flex w-full items-center justify-center gap-3 rounded-md bg-[#1D9BF0] px-3 py-1.5 text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#1D9BF0]"
            }, _hoisted_13)
          ])
        ])
      ]),
      _hoisted_14
    ])
  ]))
}